/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const progressBarStyle = {
  progressBarContainer: (theme: Theme) => ({
    margin: "3rem 0 1.5rem 0",
    [theme.breakpoints.down("sm")]: {
      marginTop: "1.5rem",
    },
  }),
  label: {
    textAlign: "center",
  },
  active: {
    color: "primary.main",
  },
  inactive: {
    color: "text.secondary",
  },
  iconContainer: {
    textAlign: "center",
    flexGrow: 0,
    maxWidth: "25%",
    flexBasis: "25%",
  },
  icon: {
    width: "50px",
    height: "50px",
  },
  shifted: {
    marginTop: "-50px",
  },
  line: {
    borderRadius: "5px",
    marginTop: "10px",
    minHeight: "38px",
    maxWidth: "100%",
  },
};

export default progressBarStyle;
